@if (visible()) {
  <div
    #wrapper
    class="alert-wrapper"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <ngb-alert
      type="custom"
      class="alert"
      [class]="alertClass()"
      [dismissible]="false">
      <span
        class="alert-icon freshicon freshicon-lg"
        [class]="alertIconClass()"></span>
      <div class="alert-content">
        <h3 class="alert-heading">{{ alert()?.title }}</h3>
        <p class="alert-message">{{ alert()?.message }}</p>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close alert"
        (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </ngb-alert>
  </div>
}
